import { type FunctionComponent, type RefObject, useEffect } from 'react';
import { addClassesFromProps } from '../basicFunctions';

interface HeadingProps {
  headerText: string;
  documentTitle?: string;
  extraClassName?: string;
  sizeClass?: 'hw-h1' | 'hw-h2' | 'hw-h3' | 'hw-text-title';
  dataTestid?: string;
  forwardRef?: RefObject<HTMLHeadingElement | null>;
}

export const HEADING_CONTENT_ID = 'headingcontent';

const Heading: FunctionComponent<HeadingProps> = ({
  headerText,
  documentTitle,
  extraClassName,
  sizeClass = 'hw-h1',
  dataTestid,
  forwardRef: ref,
}) => {
  useEffect(() => {
    document.title = `${documentTitle || headerText} | Posten signering`;
  }, [documentTitle, headerText]);

  return (
    <h1
      id={HEADING_CONTENT_ID}
      tabIndex={-1}
      className={`${sizeClass} no-outline hw-color-primary-darker${addClassesFromProps(
        extraClassName
      )}`}
      data-testid={dataTestid}
      dangerouslySetInnerHTML={{ __html: headerText }}
      ref={ref}
    />
  );
};

export default Heading;
